// extracted by mini-css-extract-plugin
var _1 = "Page-modulecontent__qLC0M";
var _2 = "Page-modulepage__yu32Y";
var _3 = "Page-modulescrollWrapper__K0I09";
var _4 = "Page-modulewithModalsTray__yHj8b";
var _5 = "Page-modulewithSupportButtons__qLkdr";
export { _1 as "content", _2 as "page", _3 as "scrollWrapper", _4 as "withModalsTray", _5 as "withSupportButtons" }
